import React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { USER_API_URL } from "src/api/axios";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { useQuery } from 'react-query';
import { Card, Table, TableBody, TableCell, TableContainer, TableRow, Chip, Box, TablePagination } from "@material-ui/core";
import { Paper, IconButton, InputBase } from "@mui/material";
import LoadingScreen from "src/components/LoadingScreen";
import { styled } from '@mui/material/styles';
import UserListHead from "src/components/user/UserListHead";
import Stack from '@mui/material/Stack';
import SearchIcon from "src/svgComponents/SearchIcon";
import moment from "moment";

const _ = require('lodash');

const OrderDetail = () => {
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [page, setPage] = useState(0);
   const axiosPrivate = useAxiosPrivate();
   const { state } = useLocation();
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [loding, setLoding] = useState(true);
   const [tableData, setTableData] = useState([]);
   const [filterName, setFilterName] = useState('');
   const [totalOrder, setTotalNoOrder] = useState(0);
   const [orderAmount, setTotalOrderAmount] = useState(0);
   const [walletAmount, setWalletAmount] = useState(0);

   const filteredData = applySortFilter(tableData, getComparator(order, orderBy));


   async function getOrderDetail(page, filterName) {
      const response = await axiosPrivate.get(USER_API_URL.userOrderdetail + state?.orderDetails?._id, { params: { page: page + 1, search: filterName, limit: rowsPerPage } })
      setTotalNoOrder(response?.data?.total_order);
      setTotalOrderAmount(formatCount(response?.data?.total_order_amount));
      setWalletAmount(formatCount(response?.data?.wallet_amount));
      return response.data.order_list[0];
   }

   const { data: orderList, refetch } = useQuery(['orderList', page, filterName], () => getOrderDetail(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (orderList) {
         setTableData(orderList.data);
         setRowsPerPage(orderList?.metadata.length != 0 ? orderList?.metadata[0].limit : 10);
      }
      if (orderList?.metadata.length != 0 && orderList?.metadata[0].hasMoreData == true) {
         getOrderDetail(page + 1);
      }
      setLoding(false);
   }, [orderList])
   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
      setTimeout(() => {
         refetch();
      }, 500);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };

   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   const formatCount = (count) => {
      // function done by shreya
      const COUNT_ABBRS = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
      const decimals = 2;
   
      const i = 0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));
      let result= parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
      // if (withAbbr) {
      result += `${COUNT_ABBRS[i]}`;
      // }
      let value = count;
      if (count >= 1000) {
         value = result;
      }
      return value;
   };
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });

      return stabilizedThis.map((el) => el[0]);
   }

   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'order_id', label: 'Order Id', alignRight: false },
      { id: 'total_order_amount', label: 'Total Order Amount', alignRight: false },
      { id: 'created_at', label: 'Order Date', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
   ];
   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      console.log(filterName)
      setPage(0);
      getOrderDetail(page, filterName)
      refetch();
   };
   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };


   return (
      <>
         {loding ? <LoadingScreen /> : <>

            <div className="row">
               <h4 className="app_text_20_semibold">Order Details </h4>
               <div className="container-fluid mt-4 px-0">
                  <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-3  g-5">
                     <div className="col">
                        <div className="card text-center  dashbaoard_card">
                           <div className="justify-content-evenly card-header" style={{ "backgroundColor": "#282a3a", "color": "#fff" }}>
                              No Of orders
                           </div>
                           <div className="card_content" style={{ "margin": "5px", "padding": "5px" }}>
                              <span className="app_text_36_bold">{totalOrder}</span>
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="card text-center  dashbaoard_card">
                           <div className="justify-content-evenly card-header" style={{ "backgroundColor": "#282a3a", "color": "#fff" }}>
                              Total Order Amount
                           </div>
                           <div className="card_content" style={{ "margin": "5px", "padding": "5px" }}>
                              <span className="app_text_36_bold">£{orderAmount}</span>
                           </div>
                        </div>
                     </div>
                     <div className="col">
                        <div className="card text-center  dashbaoard_card">
                           <div className="justify-content-evenly card-header" style={{ "backgroundColor": "#282a3a", "color": "#fff" }}>
                              Wallet Amount
                           </div>
                           <div className="d-flex justify-content-evenly" style={{ "margin": "5px", "padding": "5px" }}>
                              <span className="app_text_36_bold">£{walletAmount}</span>
                           </div>
                        </div>
                     </div>

                  </div>
               </div>
            </div>
            <Box sx={{ mt: 5 }}>
               <div className="dashboard_header mb-4">
                  <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Order List</h4>
                  <Paper component="form" className='dashboard_searchbox col-lg-4'>
                     <IconButton>
                        <SearchIcon />
                     </IconButton>
                     <InputBase
                        fullWidth
                        sx={{ flex: 1 }}
                        placeholder="search order..."
                        onChange={(e) => handleFilterByName(e)}
                     />
                  </Paper>

               </div>
               <Card>
                  <TableContainer>
                     <Table>
                        <UserListHead
                           headLabel={TABLE_HEAD}
                           rowCount={orderList?.data?.length}
                           onRequestSort={handleRequestSort}
                        />
                        {filteredData?.length > 0 ?
                           <TableBody>
                              {filteredData.map((row) => {
                                 return (
                                    <StyledTableRow key={row._id}>
                                       <TableCell component="th" scope="row">
                                          {row.order_id}
                                       </TableCell>
                                       <TableCell align="left"> {row?.total_amount}</TableCell>
                                       <TableCell align="left"> {moment(row?.createdAt).format("MMM DD YYYY")}</TableCell>
                                       <TableCell>
                                          <Stack direction="row" spacing={3}>
                                             {
                                                row.status == 0 ? <Chip variant="contained" className="app_status_chip pending" label="Pending" /> :(row.status == 1 ? <Chip variant="contained" className="app_status_chip in_progress" label="In Progress " /> : (row.status == 2 ? <Chip variant="contained" className="app_status_chip Completed" label="Completed " /> :  <Chip variant="contained" className="app_status_chip invalid" label="Reject" />))
                                             }
                                          </Stack>
                                       </TableCell>
                                    </StyledTableRow>
                                 )
                              })}
                           </TableBody>
                           :
                           <TableBody>
                              <TableRow>
                                 <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                    <span className="app_text_16_semibold">No Data Found</span>
                                 </TableCell>
                              </TableRow>
                           </TableBody>}
                     </Table>
                  </TableContainer>
                  <TablePagination
                     component="div"
                     rowsPerPageOptions={[10, 20, 50, 100]}
                     count={orderList?.metadata.length != 0 ? orderList?.metadata[0].total : 0}
                     rowsPerPage={rowsPerPage}
                     page={page}
                     onPageChange={handleChangePage}
                     onRowsPerPageChange={handleChangeRowsPerPage}
                  />
               </Card>
            </Box>
         </>
         }
      </>
   )
}

export default OrderDetail